// extracted by mini-css-extract-plugin
module.exports = {"grid":"Grid_grid__BQ5oR","empty":"Grid_empty__ohdZi","featured":"Grid_featured__JiUKx"};